import { useState } from 'react';
import { Camera, Plus } from 'lucide-react';
import { C } from '../config/constants';
import Acordio from './Acordio';

export default function Galeria({ galeria, isAdmin, onSeccioClick,
  onAfegirSeccio, onEditarSeccio, onAfegirCurs }) {

  const [openCurs, setOpenCurs] = useState(null);

  const cursos = Object.keys(galeria).sort((a, b) => {
    const ya = parseInt(a.match(/\d{4}/)?.[0]) || 0;
    const yb = parseInt(b.match(/\d{4}/)?.[0]) || 0;
    return yb - ya;
  });

  return (
    <section id="galeria" style={{ padding: '5rem 1.5rem' }}>
      <div style={{ maxWidth: 780, margin: '0 auto' }}>

        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
            background: 'rgba(255,255,255,0.1)', color: '#fff',
            padding: '0.4rem 1rem', borderRadius: '999px',
            fontSize: '0.8rem', fontWeight: 700, marginBottom: '1rem',
          }}><Camera size={14}/> Arxiu fotogràfic</div>
          <h2 style={{
            fontFamily: "'Fredoka',sans-serif",
            fontSize: 'clamp(1.9rem,3.2vw,2.5rem)', fontWeight: 600,
            color: '#fff', marginBottom: '0.75rem',
          }}>Galeria de fotos</h2>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.98rem', maxWidth: 440, margin: '0 auto' }}>
            Selecciona un curs per veure les fotos. Necessitaràs la contrasenya del Casalot.
          </p>
        </div>

        <div>
          {cursos.map(etiqueta => (
            <Acordio
              key={etiqueta}
              etiqueta={etiqueta}
              seccions={galeria[etiqueta] || {}}
              isOpen={openCurs === etiqueta}
              onToggle={() => setOpenCurs(p => p === etiqueta ? null : etiqueta)}
              onSeccioClick={onSeccioClick}
              isAdmin={isAdmin}
              onAfegirSeccio={onAfegirSeccio}
              onEditarSeccio={onEditarSeccio}
            />
          ))}
        </div>

        {isAdmin && (
          <button onClick={onAfegirCurs} style={{
            display: 'flex', alignItems:'center', justifyContent:'center', gap:8,
            width: '100%', marginTop: '0.75rem',
            border: '2px dashed rgba(255,215,0,0.4)', borderRadius: C.radiusSm,
            padding: '1rem', background: 'transparent', color: C.groc,
            fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', fontFamily: 'inherit',
          }}><Plus size={16}/> Afegir nou curs</button>
        )}
      </div>
    </section>
  );
}